/** CAMPAIGN */
import { HallowAnalyticsEvent } from "@packages/analytics";
import { Link } from "@packages/framework";

import { Button } from "../../../_core/Button/Button.emotion";
import type { CampaignLargeProps } from "../../campaigns/CampaignLarge/CampaignLarge.emotion";
import type { CampaignLargeWithAuthorProps } from "../../campaigns/CampaignLargeWithAuthor/CampaignLargeWithAuthor.emotion";
import type { CampaignMediumProps } from "../../campaigns/CampaignMedium/CampaignMedium.emotion";
import type { BaseGetSectionItemProps } from "./Section.emotion";

export const getSectionItemCampaignProps = ({
  analytics,
  item,
  link,
  section,
  pageId,
  t,
  screenName,
}: BaseGetSectionItemProps): CampaignLargeWithAuthorProps => {
  let authorName: string = undefined;
  if (item?.reference?.organizer?.name && item.reference.organizer.last_name) {
    authorName = `${item.reference.organizer.name} ${item.reference.organizer.last_name}`;
  } else if (item?.reference?.organizer?.name) {
    authorName = item.reference.organizer.name;
  }
  return {
    authorProps: {
      avatarProps: {
        imgSrc: item?.reference?.organizer?.image_url,
      },
      name: authorName,
    },
    campaignId: item?.reference.id,
    campaignName: item?.reference.name,
    campaignLargeProps: {
      actions: link ? (
        <Button
          asChild
          key="links"
          onPointerUp={() => {
            analytics?.track({
              event: HallowAnalyticsEvent.TappedSectionItem,
              properties: {
                // Refactor: This event should be logged for every Section Item (move event up DOM tree)
                page_id: pageId,
                screen_name: screenName ?? null,
                section_id: section?.id,
                section_item_id: item?.item_id ?? null,
                section_title: section?.title ?? null,
                section_type: section?.type ?? null,
                index: section?.items.indexOf(item) ?? null,
                item_type: item?.type ?? null,
                section_cohort_id: section?.cohorts?.map((c) => c.id) ?? null,
                section_cohort: section?.cohorts?.map((c) => c.name) ?? null,
              },
            });
          }}
          onClickCapture={() => {
            analytics.track({
              event: HallowAnalyticsEvent.TappedDetails,
              properties: {
                section_item_id: item?.item_id ?? null,
                collection_id: null,
              },
            });
          }}
          variant="lighten"
        >
          <Link href={`/campaigns/${item?.reference.id}`}>
            {t("web_details")}
          </Link>
        </Button>
      ) : null,
      campaignLargeMobileProps: {
        asChild: link,
        children: <Link href={`/campaigns/${item?.reference.id}`} />,
      },
    },
    color: item?.reference?.content_image
      ?.color_hex as CampaignLargeProps["color"],
    description: item?.reference?.name,
    imgSrc: item?.reference?.image,
    illustrationImgSrc: item?.reference?.content_image?.large,
    item: item,
    joined: item?.reference?.has_joined,
    hasEnded: new Date() > new Date(item?.reference?.ends_at),
    section: section,
    tags: item?.reference?.labels,
    title: item?.reference?.content_title,
  };
};

export type GetSectionItemCampaignMediumPropsProps = BaseGetSectionItemProps;

export const getSectionItemCampaignMediumProps = ({
  item,
  link,
}: GetSectionItemCampaignMediumPropsProps): CampaignMediumProps => ({
  asChild: link,
  children: link ? <Link href={`/campaigns/${item?.reference?.id}`} /> : null,
  color: item?.reference?.content_image
    ?.color_hex as CampaignLargeProps["color"],
  description: item?.reference?.name,
  imgSrc: item?.reference?.image,
  illustrationImgSrc: item?.reference?.content_image?.large,
  metadata: item?.reference?.labels[0],
  title: item?.reference?.content_title,
});
